export default __webpack_public_path__ + "static/media/butterFly.2a74577b.png";